import { Segment, SegmentContent, SegmentHeader } from '@/platform/ui';
import { usePage } from '@inertiajs/react';
import dayjs from 'dayjs';
import { useState } from 'react';
import LkvEntitlementCard from './components/LkvEntitlementCard';
import LkvEntitlementPanel from './components/LkvEntitlementPanel';
import EmployeeShowLayout from './layouts/EmployeeShowLayout';

const LkvView = () => {
    const { employee } = usePage().props;

    const [editing, setEditing] = useState(null);

    const entitlements = [...(employee?.lkv_entitlements ?? [])].sort((a, b) =>
        dayjs(b.start_date).diff(dayjs(a.start_date))
    );

    return (
        <>
            {entitlements.length === 0 ? (
                <Segment>
                    <SegmentHeader header='LKV' />
                    <SegmentContent>
                        <p className='text-sm text-gray-500'>
                            Deze werknemer heeft nog geen LKV.
                        </p>
                    </SegmentContent>
                </Segment>
            ) : (
                entitlements.map(entitlement => (
                    <LkvEntitlementCard
                        entitlement={entitlement}
                        onEdit={setEditing}
                        key={entitlement.id}
                    />
                ))
            )}

            {editing && (
                <LkvEntitlementPanel
                    entitlement={editing}
                    onClose={() => setEditing(null)}
                />
            )}
        </>
    );
};

LkvView.layout = page => <EmployeeShowLayout>{page}</EmployeeShowLayout>;

export default LkvView;
